import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';

import { occupationDetailWithBusinessRulesReady } from '../occupation-detail/occupation-detail.actions';
import { licensesLoadedSuccess, loadLicenses } from './license.actions';
import { OccupationDetailFacade } from '../occupation-detail';

@Injectable()
export class LicenseEffects {
  occupationDetailWithBusinessRulesReady$ = createEffect(() =>
    this.actions$.pipe(
      ofType(occupationDetailWithBusinessRulesReady),
      map(() => loadLicenses())
    )
  );

  loadLicenses$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loadLicenses),
      withLatestFrom(this.occupationDetailFacade.occupationDetail$),
      switchMap(([action, { licenses }]) => {
        return of(
          licensesLoadedSuccess({
            licenses: licenses
          })
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private occupationDetailFacade: OccupationDetailFacade
  ) {}
}
